<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import { faClone, faPen, faEraser, faArrowsAlt, faCaretLeft, faCheck, faEdit, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { faCircle } from '@fortawesome/free-regular-svg-icons'
    import { createEventDispatcher, onMount, tick } from 'svelte'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    import ImagePic from '../../_common/ImagePic.svelte'
    import Zdraggable from '../../_common/z/zdraggable.svelte'
    import { draw } from 'svelte/transition'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let editable: boolean
    export let value: FormDataContent = new FormDataContent()
    export let view = false
    export let paint: boolean

    interface imageItem {
        url: string
        points: { type: string; x: number; y: number; color: string; label: string; value: string; edit: boolean }[]
        canvas: string
    }

    let step = 0
    let locallabel = ''
    let localLocked = false
    let images: imageItem[] = []
    let newImage: string = ''
    let selectedImage: imageItem
    let pen: { type: string; color: string; label: string } = null
    let igShow
    let igShowDiv
    let igCanvas: HTMLCanvasElement
    let canvasData: string = ''

    function goPen(type: 'botox' | 'pdo' | 'preenchimento' | 'injetavel' | 'notas' | 'pen' | 'eraser' | 'circle') {
        if (view) return
        if (type === 'botox') {
            pen = { type: 'botox', color: '#0D47A1', label: 'un' }
        }
        if (type === 'pdo') {
            pen = { type: 'pdo', color: '#FF9100', label: 'mm' }
        }
        if (type === 'preenchimento') {
            pen = { type: 'preenchimento', color: '#C51162', label: 'ml' }
        }
        if (type === 'injetavel') {
            pen = { type: 'injetavel', color: '#FFAB00', label: 'ml' }
        }
        if (type === 'notas') {
            pen = { type: 'notas', color: '#0D47A1', label: '' }
        }
        if (type === 'pen') {
            pen = { type: 'pen', color: '#0AAE66', label: '' }
        }
        if (type === 'circle') {
            pen = { type: 'circle', color: '#0AAE66', label: '' }
        }
        if (type === 'eraser') {
            pen = { type: 'eraser', color: '#FFFFFF', label: '' }
        }
    }

    function setPoint(ev) {
        if (!selectedImage) return
        if (!pen) return
        if (view) return
        let point = {
            type: pen.type,
            color: pen.color,
            label: pen.label,
            x: Math.round((100 / igShow.width) * ev.offsetX * 100) / 100,
            y: Math.round((100 / igShow.height) * ev.offsetY * 100) / 100,
            value: '',
            edit: true,
        }
        selectedImage.points.push(point)
        selectedImage = selectedImage
        setTimeout(() => {
            document.getElementById('ig_show_edit_input_' + (selectedImage.points.length - 1))?.focus()
        }, 100)
    }

    function editPoint(index) {
        selectedImage.points[index].edit = true
        setTimeout(() => {
            document.getElementById('ig_show_edit_input_' + index)?.focus()
        }, 100)
    }

    function removeImage(index) {
        if (view) return
        if (!confirm('Deseja mesmo remover este item?')) return
        if (images[index].url === selectedImage?.url) selectedImage = null
        images.splice(index, 1)
        images = images
    }

    function removePoint(index) {
        if (view) return
        selectedImage.points.splice(index, 1)
        selectedImage = selectedImage
    }

    function emitChange(ev) {
        if (ev.detail.base64) {
            images.push({
                url: ev.detail.base64,
                points: [],
                canvas: canvasData,
            })
            images = images
            newImage = ''
            if (!selectedImage) goSelect(images.length - 1)
        }
        dispatch('change')
    }

    async function goSelect(index: number) {
        selectedImage = images[index]
        await tick()
    }

    function goEdit() {
        locallabel = item.label || ''
        localLocked = item.locked
        step = 2 // edição
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        step = 1 // visualização
        dispatch('edit', false)
    }

    function goSave() {
        if (locallabel.trim().length === 0) {
            window.error('Informe o texto a ser adicionado')
            return
        }
        item.label = locallabel
        item.locked = true // localLocked
        item.score = false
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    let scale = 1
    let resizing = false
    function configureZoom() {
        igShowDiv.addEventListener('wheel', (e) => {
            // Calcula a posição do mouse relativa ao div_in
            const rect = igShowDiv.getBoundingClientRect()
            const offsetX = e.clientX - rect.left
            const offsetY = e.clientY - rect.top

            // Ajusta a origem do zoom para a posição do cursor
            const originX = (offsetX / rect.width) * 100
            const originY = (offsetY / rect.height) * 100
            igShowDiv.style.transformOrigin = `${originX}% ${originY}%`

            // Aplica o zoom
            scale += e.deltaY * -0.005
            scale = Math.min(Math.max(1, scale), 3) // Limita o zoom entre 1x e 3x
            igShowDiv.style.transform = `scale(${scale})`

            if (scale > 1) resizing = true
            if (resizing) e.preventDefault()
            if (scale === 1) setTimeout(() => (resizing = false), 300)
        })
    }

    // Voltar para uma foto já vista traz a imagem do cache, já completa: nesse caso o `load` não
    // dispara de novo e o canvas de marcação ficava sem ser redesenhado. O `loadCanvas` já espera
    // um tick e sai sozinho quando não há marcação, então chamar aqui é seguro.
    $: if (igShow && selectedImage && igShow.complete) loadCanvas()

    async function loadCanvas() {
        igCanvas.width = igCanvas.offsetWidth
        igCanvas.height = igCanvas.offsetHeight
        await tick()
        if (!selectedImage.canvas) return
        const img = new Image()
        img.src = selectedImage.canvas
        img.onload = () => {
            ctx.clearRect(0, 0, igCanvas.width, igCanvas.height) // Limpa o canvas
            ctx.drawImage(img, 0, 0) // Desenha a imagem no canvas
        }
    }

    let drawing = false
    let ctx: CanvasRenderingContext2D
    let startX = 0
    let startY = 0
    let tempData = ''
    let lastX
    let lastY
    function configureCanvas() {
        ctx = igCanvas.getContext('2d')
        igCanvas.addEventListener('pointerdown', async (e) => {
            if (pen?.type !== 'pen' && pen?.type !== 'eraser' && pen?.type !== 'circle') return
            drawing = true
            startX = e.offsetX
            startY = e.offsetY
            if (pen.type === 'circle') {
                tempData = igCanvas.toDataURL('image/png')
            }
            const { x, y } = getCanvasPos(igCanvas, e)
            lastX = x
            lastY = y
            count = 0
            ctx.beginPath()
            //ctx.moveTo(e.offsetX, e.offsetY)
        })

        let count = 0 // segmenta o traço de tempos em tempos para o blur não ficar alterando o tempo todo.
        igCanvas.addEventListener('pointermove', (e) => {
            if (!drawing) return

            const { x, y } = getCanvasPos(igCanvas, e)

            const midX = (lastX + x) / 2
            const midY = (lastY + y) / 2
            if (pen.type === 'eraser') {
                ctx.globalCompositeOperation = 'destination-out' // Modo borracha
                ctx.lineWidth = 32 // Espessura da borracha
                ctx.lineTo(e.offsetX, e.offsetY)
                ctx.stroke()
            } else if (pen.type === 'circle') {
                ctx.clearRect(0, 0, igCanvas.width, igCanvas.height) // Limpa o canvas para mostrar o novo circulo redimensionado
                const img = new Image()
                img.src = tempData
                ctx.drawImage(img, 0, 0) // Desenha a imagem no canvas
                const radius = Math.sqrt((e.offsetX - startX) ** 2 + (e.offsetY - startY) ** 2) // Calcula o raio do círculo
                ctx.globalCompositeOperation = 'source-over' // Modo lápis
                ctx.beginPath()
                ctx.arc(startX, startY, radius, 0, Math.PI * 2) // Desenha o círculo redimensionado
                ctx.strokeStyle = pen.color // Cor da borda
                ctx.lineWidth = 3 // Espessura da borda
                ctx.stroke()
            } else {
                count++
                if (count % 120 === 0) ctx.beginPath()
                //
                ctx.shadowColor = pen.color
                ctx.shadowBlur = 1.3 // ajuste fino
                //
                ctx.globalCompositeOperation = 'source-over' // Modo lápis
                ctx.lineCap = 'round'
                ctx.lineJoin = 'round'
                ctx.strokeStyle = pen.color // Cor do lápis
                ctx.lineWidth = 2 // Espessura do lápis
                //ctx.lineTo(x, y)
                ctx.quadraticCurveTo(lastX, lastY, midX, midY)
                ctx.stroke()
                lastX = x
                lastY = y
            }
        })

        function getCanvasPos(canvas, e) {
            const rect = canvas.getBoundingClientRect()

            const scaleX = canvas.width / rect.width
            const scaleY = canvas.height / rect.height

            return {
                x: (e.clientX - rect.left) * scaleX,
                y: (e.clientY - rect.top) * scaleY,
            }
        }

        igCanvas.addEventListener('mouseup', async () => {
            if (!drawing) return
            drawing = false
            ctx.closePath()
            await tick()
            selectedImage.canvas = igCanvas.toDataURL('image/png')
        })
    }

    let isNew = false
    onMount(async () => {
        if (!value.value) value.value = []
        images = value.value
        if (images.length > 0) goSelect(0)
        isNew = editable && !item.label?.length
        if (isNew) {
            goEdit()
        } else {
            step = 1
            await tick()
            configureZoom()
            configureCanvas()
        }
    })

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_input_line cs_element-editable-{editable} {className}" class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}

        <div class="cs_element_content">
            <div class="cs_item_title content_question">
                {@html item.label || ''}
            </div>
            <div class="content_answer">
                <div class="ig">
                    {#each images as image, ind}
                        <div class="ig_image ig_image-preview" on:click={() => goSelect(ind)}>
                            <img src={image.url} alt="" />
                            {#if !view}
                                <button on:click|stopPropagation={() => removeImage(ind)} class="btn btn-sm btn-outline-secondary ig_image-preview_trash"
                                    ><Fa icon={faTrash}></Fa></button
                                >
                            {/if}
                        </div>
                    {/each}
                    {#if !view}
                        <div class="ig_image">
                            <ImagePic upload={true} disabled={view} bind:base64={newImage} on:change={emitChange} />
                        </div>
                    {/if}
                </div>

                <div class="ig_content">
                    {#if paint && selectedImage}
                        <Zdraggable left={4} top={4}>
                            <div class="ig_pens">
                                <div class="ig_pens_header"><Fa icon={faArrowsAlt}></Fa></div>
                                <div class="ig_pens_body">
                                    <div on:click={() => goPen('preenchimento')} class="ig_pen" class:ig_pen-active={pen?.type === 'preenchimento'}>
                                        <div class="ig_point ig_point-preenchimento"></div>
                                        <div class="ig_label">Preenchimento</div>
                                    </div>
                                    <div on:click={() => goPen('botox')} class="ig_pen" class:ig_pen-active={pen?.type === 'botox'}>
                                        <div class="ig_point ig_point-botox"></div>
                                        <div class="ig_label">Toxina botulínica</div>
                                    </div>
                                    <div on:click={() => goPen('injetavel')} class="ig_pen" class:ig_pen-active={pen?.type === 'injetavel'}>
                                        <div class="ig_point ig_point-injetavel"></div>
                                        <div class="ig_label">Injetável</div>
                                    </div>
                                    <div on:click={() => goPen('pdo')} class="ig_pen" class:ig_pen-active={pen?.type === 'pdo'}>
                                        <div class="ig_point ig_point-pdo"></div>
                                        <div class="ig_label">Fio de PDO</div>
                                    </div>
                                    {#if !view}
                                        <div on:click={() => goPen('pen')} class="ig_pen" class:ig_pen-active={pen?.type === 'pen'}>
                                            <div class="-pen"><Fa icon={faPen}></Fa></div>
                                            <div class="ig_label">Lápis</div>
                                        </div>
                                        <div on:click={() => goPen('circle')} class="ig_pen" class:ig_pen-active={pen?.type === 'circle'}>
                                            <div class="-pen"><Fa icon={faCircle}></Fa></div>
                                            <div class="ig_label">Círculo</div>
                                        </div>
                                        <div on:click={() => goPen('eraser')} class="ig_pen" class:ig_pen-active={pen?.type === 'eraser'}>
                                            <div class="-eraser"><Fa icon={faEraser}></Fa></div>
                                            <div class="ig_label">Borracha</div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </Zdraggable>
                    {/if}
                    <div class="ig_show_outer">
                        <div class="ig_show" bind:this={igShowDiv}>
                            {#if selectedImage}
                                {#each selectedImage.points as point, index}
                                    <div class="ig_show_pen" style="top:{point.y}%;left:{point.x}%;">
                                        <div on:click={() => editPoint(index)} class="ig_point ig_point-{point.type} ig_show_point"></div>
                                        {#if point.edit && !view}
                                            <div class="ig_show_edit">
                                                <div class="input-group input-group-sm">
                                                    <input
                                                        id="ig_show_edit_input_{index}"
                                                        type="number"
                                                        step=".1"
                                                        bind:value={point.value}
                                                        class="form-control"
                                                        on:keydown={(ev) => {
                                                            if (ev.key === 'Enter') {
                                                                point.edit = false
                                                            }
                                                        }}
                                                    />
                                                    <label for="" class="input-group-text">{point.label}</label>
                                                    <button on:click={() => (point.edit = false)} class="btn btn-secondary btn-sm"
                                                        ><Fa icon={faCheck}></Fa></button
                                                    >
                                                    <button on:click={() => removePoint(index)} class="btn btn-warning btn-sm"><Fa icon={faTimes}></Fa></button>
                                                </div>
                                            </div>
                                        {:else}
                                            <div class="ig_show_label ig_point-{point.type}">
                                                {point.value}
                                                {point.label}
                                            </div>
                                        {/if}
                                    </div>
                                {/each}
                            {:else}
                                <div class="ig_show_empty text-muted text-center">Selecione uma imagem para abrir</div>
                            {/if}

                            <img
                                id="igShow"
                                on:click={(ev) => setPoint(ev)}
                                on:load={loadCanvas}
                                bind:this={igShow}
                                src={selectedImage?.url}
                                alt=""
                                class:ig_show_image_crosshair={!!pen}
                            />
                            <canvas
                                bind:this={igCanvas}
                                id="canvas"
                                class="ig_show_canvas"
                                class:ig_show_canvas-is-active={pen?.type === 'pen' || pen?.type === 'eraser' || pen?.type === 'circle'}
                                class:eraser_cursor={pen?.type === 'eraser'}
                                class:circle_cursor={pen?.type === 'circle'}
                                class:pen_cursor={pen?.type === 'pen'}
                            ></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:else}
        <div class="acts acts_2 acts-absolute">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>

        <label for="" class="cs_item_title edit_question">Título</label>
        <div class="input-inline">
            <input type="text" bind:value={locallabel} class="" />
            <!-- <div class="form-check form-switch cs-w-150">
                <input
                    class="form-check-input"
                    bind:checked={localLocked}
                    type="checkbox"
                    role="switch"
                    id="localLocked"
                />
                <label class="form-check-label" for="localLocked">Apenas leitura</label>
            </div> -->
        </div>
    {/if}
</div>
